module.exports = __webpack_public_path__ + "static/media/happy-parent-baner-main.32dad987.png";